/**
* @file 业务设置-下单区域限制
* */
<template>
  <div id="basic">
    <div class="blueInfo" style="width: 800px">
      <p>
        * 勾选地区的乘客身份证号码，将禁止下单
        <br>
        * 票务设置中启用了实名购票，下单区域限制才会生效
      </p>
    </div>

    <div style="width:760px;padding:20px 0;display: inline-block;">
      <el-checkbox :indeterminate="checkAllIsIndeterminate" v-model="checkAllStatus" @change="handleCheckAllChange" style="margin-bottom: 3rem">全选</el-checkbox>

      <div v-for="(item,index) in form" :key="index">
        <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkProvince" @change="handleCheckProvinceChange(item)">{{item.name}}</el-checkbox>
        <el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange(item)" style="margin:1rem 2.5rem 3rem">
          <el-checkbox v-for="area in item.areaList" :key="area.code" :label="area.code">{{area.name}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <el-button type="primary" style="vertical-align: top;margin:20px 0;" @click="postFn" :loading="loading">保存</el-button>
  </div>
</template>

<script>
import administrativeDistrict from "../../../../public/administrativeDistrict";
export default {
  name: "basic",
  data() {
    return {
      form: null, // 表单
      checkAllStatus: false,
      checkAllIsIndeterminate: false, // 薛定谔状态
      loading: false, // 保存按钮loading
    };
  },
  created() {
    this.initData();
    this.restrictedAreaInfo();
  },
  methods: {
    /* 数据初始化 */
    initData() {
      administrativeDistrict[0].forEach(item => {
        item.isIndeterminate = null;
        item.checkProvince = false;
        item.checkedCities = [];
      })
      this.form = JSON.parse(JSON.stringify(administrativeDistrict[0]));
    },
    /* 全选 */
    handleCheckAllChange(checkStatus) {
      this.checkAllIsIndeterminate = false;
      if (checkStatus) {
        this.form.map(item => {
          item.checkProvince = true;
          if (['110000', '120000', '500000', '310000', '810000', '820000', '710000'].includes(item.code)) return;
          item.checkedCities = [];
          item.isIndeterminate = false;
          item.areaList.map(city => {
            item.checkedCities.push(city.code)
          })
        })
      } else {
        this.initData();
      }

    },
    /* 省选 */
    handleCheckProvinceChange(item) {
      this.checkAllIsIndeterminate = false;
      this.checkAllStatus = false;
      item.checkedCities = item.checkProvince && item.areaList ? item.areaList.map(city => city.code) : [];
      item.isIndeterminate = false;
    },
    /* 市选 */
    handleCheckedCitiesChange(item) {
      this.checkAllIsIndeterminate = false;
      this.checkAllStatus = false;
      let checkedCount = item.checkedCities.length;
      item.checkProvince = checkedCount === item.areaList.length;
      item.isIndeterminate = checkedCount > 0 && checkedCount < item.areaList.length;
    },
    getCity(area = []) {
      this.form.map(item => {
        if (item.checkProvince) {
          if (['110000', '120000', '500000', '310000', '810000', '820000', '710000'].includes(item.code)) {
            // 直辖市处理
            area.push({
              province: item.name,
              provinceCode: item.code,
              idCode: item.idCode
            })
          } else {
            // 标准省份处理
            area.push(...item.areaList.map(city => {
              return {
                province: item.name,
                provinceCode: item.code,
                city: city.name,
                cityCode: city.code,
                // idCode: city.code.substring(0, 4)
              }
            }))
          }
        } else {
          item.checkedCities.map(code => {
            let saved = []; // 装载已匹配过的数据
            item.areaList.map(city => {
              if (saved.includes(city.code)) return;
              if (city.code == code) {
                saved.push(city.code);
                area.push({
                  province: item.name,
                  provinceCode: item.code,
                  city: city.name,
                  cityCode: city.code
                })
              }
            })
          })
        }
      })
      return area;
    },
    /* 获取配置详情 */
    async restrictedAreaInfo() {
      let url = '/api/v1/manage/restrictedArea';
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {

        data.data.map(row => {
          this.form.map(item => {
            if (row.provinceCode == item.code) {
              if (row.city) {
                item.checkedCities.push(row.cityCode)
                if (item.checkedCities.length == item.areaList.length) {
                  item.checkProvince = true;
                  item.isIndeterminate = false;
                } else {
                  item.isIndeterminate = true;
                }
              } else {
                item.checkProvince = true;
              }
            }
          })
        })


        let checkAllStatus = true;
        this.form.map(item => {
          let match = false;
          data.data.map(row => {
            if (row.provinceCode == item.code) {
              match = true;
              if (row.city) {
                item.checkedCities.push(row.cityCode)
                if (item.checkedCities.length == item.areaList.length) {
                  item.checkProvince = true;
                  item.isIndeterminate = false;
                  match = true;
                } else {
                  item.isIndeterminate = true;
                }
              } else {
                item.checkProvince = true;
              }
            }
          })
          if (!match) {
            checkAllStatus = match;
          }
        })

        this.checkAllStatus = checkAllStatus;
      }
    },
    /* 接口请求-提交配置 */
    async postFn() {
      this.loading = true;
      let area = this.getCity();

      // return;
      let url = '/api/v1/manage/restrictedArea';
      let data = await this.$axios.post(url, { area: JSON.stringify(area) });
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        // this.restrictedAreaInfo();
      }
      this.loading = false;
    }
  },
};
</script>

<style lang="less">
#basic {
  .el-radio-item .el-radio__label {
    font-weight: 600;
    color: #222222;
  }

  .el-radio-item + .el-radio-item {
    padding-top: 8px;
  }

  .el-radio-item .el-form-item-remark {
    padding-top: 8px;
  }
}
</style>
